import { Box, Icon, Spinner, useToast } from '@chakra-ui/react';
import React, { Fragment, useEffect, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';

import useTable from '../../../../../hooks/useTable';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { PaginateDot } from './PaginateDot';

const TableLeadsMobile = ({
  rowsPerPage,
  visualization,
  header,
  data
}: any) => {
  const initialState = [
    {
      ID_MDM__c: '-',
      NOME__c: '-',
      segmento: '-',
      Campanha__c: '-',
      LOGIN__c: '-'
    }
  ];
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const { state } = useLocation();
  const [leads, setLeads] = useState(data || initialState);

  const toast = useToast();

  const { slice, range } = useTable(leads, page, rowsPerPage);
  return (
    <>
      <div className="tw-m-3">
        <Link to={'/corretor/leads/'}>
          <button className="tw-font-bold tw-text-[#001E64]">
            <Icon as={AiOutlineArrowLeft} mr="0.5rem" />
            Voltar
          </button>
        </Link>
      </div>
      <div className=" tw-px-[1rem] tw-m-3 tw-bg-[#fff] tw-flex tw-justify-center tw-items-center tw-flex-col tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-2xl ">
        <div className="tw-text-[3vh] tw-font-bold tw-my-[2vh]">
          <p>{header}</p>
        </div>
        <div className="tw-text-[#001E64] tw-w-[100%]">
          {!loading ? (
            <div className="tw-w-[100%] tw-flex tw-flex-col tw-text-[#001E64] tw-gap-2 ">
              {slice.map((el: any, index: any) => (
                <div
                  key={index}
                  className={`${
                    +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                  } tw-flex tw-flex-col tw-gap-1 tw-border-l-[0.3rem] tw-w-[100%]  tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[2vw] `}
                >
                  <div className="">
                    ID MDM:
                    <span className="tw-font-bold">{el.ID_MDM__c || '-'}</span>
                  </div>
                  <div>
                    {' '}
                    ID Nome:{' '}
                    <span className="tw-font-bold">{el.NOME__c || '-'}</span>
                  </div>
                  <div>
                    {' '}
                    Segmento:{' '}
                    <span className="tw-font-bold">{el.segmento || '-'}</span>
                  </div>
                  <div>
                    {' '}
                    Campanha:{' '}
                    <span className="tw-font-bold">
                      {el.Campanha__c || '-'}
                    </span>
                  </div>
                  <div>
                    Vendedor:{' '}
                    <span className="tw-font-bold">{el.LOGIN__c || '-'}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <Spinner />
          )}
        </div>
        <div className="tw-flex tw-my-2 tw-justify-center tw-w-[100%]">
          <PaginateDot
            currentPage={page}
            lastPage={range}
            maxLength={5}
            setCurrentPage={setPage}
            totalData={leads}
          />
        </div>
        <Box borderBottom="1px solid #E3E3E3" w="100%" h="0" my="1rem" />

        <Link
          className="tw-flex tw-justify-between tw-w-[100%]"
          to={'/corretor/leads/'}
        >
          <button
            onClick={() => {
              console.log('');
            }}
            className="tw-border-[#001E64] tw-font-bold tw-w-[100%] tw-mb-[2vh] tw-text-[]  tw-border-[0.1rem] tw-text-[#001E64]  tw-h-[2.5rem] tw-rounded-3xl"
          >
            Voltar
          </button>
        </Link>
      </div>
    </>
  );
};

export default TableLeadsMobile;
